import Common from '../common'
var Js = Common('articleLists')
export default {
  name: 'articleLists',
  mixins: [Js],
  components: {},
  data() {
    return {
      fields: [{
          key: 'id',
          label: '文章ID',
          application: [],
          componentName: 'sls-input',
          listType: 'normal',
          width: 50
        },
        {
          key: 'title',
          label: '名称',
          application: ['编辑', '添加'],
          componentName: 'sls-input',
          listType: 'normal',
          header_search: {
            componentName: 'sls-input',
            style: 'width:160px;margin-right:2px;',
            placeholder: '请输入文章名称',
            clearable: true,
            defaultValue: '',
            optionsName: '',
            changeFunc: function(val, self) {
              if (val) {
                self.searchItem.title = val;
              } else {
                delete self.searchItem.title;
              };

            },
          },
        },
        {
          key: 'description',
          label: '费用',
          application: ['编辑', '添加'],
          componentName: 'sls-input',
          listType: 'normal',
          placeholder: '请输入文章费用',
        },
        {
          key: 'small_title',
          label: '城市',
          application: ['编辑', '添加'],
          componentName: 'sls-input',
          listType: 'normal',
        },


        {
          key: 'content',
          label: '文章内容',
          application: ['编辑', '添加'],
          componentName: 'tinymce-editor',
          listType: '',
          dialogStyle: 'width:100%;',
        },
        {
          key: "status",
          label: '状态',
          application: [],
          componentName: 'sls-select',
          optionsName: 'statusOptions',
          defaultProps: {
            label: 'text',
            value: 'value',
          },
          formatter: function(val) {
            if (val.status == 1) {
              return '启用';
            } else {
              return '关闭';
            };
          }
        },
        {
          key: 'create_time',
          label: '创建时间',
          listType: 'normal',
          placeholder: '请选择创建时间',
          header_search: {
            componentName: 'sls-date-time-range',
            style: 'width:160px;margin-right:2px;',
            start_placeholder: '创建开始时间',
            end_placeholder: '创建结束时间',
            changeFunc: function(value, self) {
              if (!value) {
                delete self.searchItem.create_time;
              } else {
                self.searchItem.create_time = ['between', value = value.map(function(e) {
                  return e / 1000;
                })]
              };

            },
          },
          width: 200,
        },
        {
          key: 'mainImg',
          label: '图片',
          customSlot: 'mainImg',
          application: ['编辑', '添加'],
          componentName: 'upload',
          listType: 'normal',
          limit: 10,
          dialogStyle: 'width:90%',
          width: 200
        },
        {
          key: 'bannerImg',
          label: '详情图',
          customSlot: 'bannerImg',
          application: ['编辑', '添加'],
          componentName: 'upload',
          listType: '',
          limit: 10,
          dialogStyle: 'width:90%',
          width: 200
        },
        {
          key: 'qrUrl',
          label: '二维码',
          customSlot: 'qrUrl',
          application: [],
          componentName: 'upload',
          listType: 'normal',
          limit: 10,
          dialogStyle: 'width:90%',
          width: 200
        },
        {
          label: '操作',
          listType: 'deal',
          width: 200
        },
      ],

      // 按钮配置
      btn_info: [

        {
          type: 'info',
          icon: 'edit',
          size: 'mini',
          position: 'list',
          text: function(data) {
            return '编辑'
          },
          func: {
            apiName: function(self) {
              return "api_articleUpdate"
            },
            formData: function(self) {
              return self.formData
            },
            postData: function(self) {
              var postData = {
                searchItem: {
                  id: self.formData.id,
                },
                data: self.submitData
              };
              if (self.submitData.parentid && self.submitData.parentid == self.formData.id) {
                self.$$notify('父级ID和子级ID重叠', 'fail');
                return false;
              } else {
                return postData;
              };
            }
          },
        },
        {
          type: 'danger',
          icon: 'delete',
          size: 'mini',
          funcType: 'submit',
          position: 'header',
          text: function(data) {
            return '删除选中'
          },
          func: {
            apiName: function(self) {
              return "api_articleUpdate"
            },
            postData: function(self) {
              var deleteArray = [];
              for (var i = 0; i < self.selectionArray.length; i++) {
                deleteArray.push(self.selectionArray[i].id);
              };
              var postData = {
                searchItem: {
                  id: ['in', deleteArray],
                },
                data: {
                  status: -1
                }
              };
              return postData;
            }
          },
        },
        {
          type: 'info',
          icon: 'edit',
          size: 'mini',
          position: 'header',
          text: function(data) {
            return '添加'
          },
          func: {
            apiName: function(self) {
              return "api_articleAdd"
            },
            formData: function(self) {
              var data = {
                title: '',
                description: '',
                mainImg: [],
              };
              return data
            },
            postData: function(self) {
              self.submitData.type = 1;
              self.submitData.menu_id = 1;
              var postData = {
                data: self.submitData
              };
              postData.saveFunction = [{
                FuncName: 'createImg',
                Param: {
                  // file: {
                  //   behavior: 2
                  // },
                  // user_no: 'U910872296194660',
                  // param: {
                  //   "page": "pages/details/details",
                  //   'scene':201
                  //   // 'scene':{
                  //   //   'res':{
                  //   //     'id':'id'
                  //   //   }
                  //   // }
                  // }, //小程序码的格式
                  res:{
                    id: 'id'
                  },
                  // refresh: true,
                  // // relation_id:201,
                  // config_id: 1,
                  // thirdapp_id: 2,
                  // type: 2
                }
              }]
              return postData;
            }
          },
        },


      ],

      searchItem: {
        menu_id: 1,
        thirdapp_id: this.$store.getters.getUserinfo.thirdapp_id
      },
      startSearchItem: {
        menu_id: 1,
        thirdapp_id: this.$store.getters.getUserinfo.thirdapp_id
      },
      optionData: {
        labelOptions: [],
        statusOptions: [{
          text: '启用',
          value: 1
        }, {
          text: '禁用',
          value: -1
        }],
      },
      otherData: {},
      UserInfo: {
        tableName: 'UserInfo',
        searchItem: {},
        key: 'user_no',
        middleKey: 'user_no',
        condition: 'in',
      }

    }

  },

  mounted() {
    const self = this;
    self.searchData = self.$$cloneForm(self.searchItem);
    this.init()
  },
  computed: {
    token: function() {
      return this.$store.getters.getToken
    }
  },
  methods: {

    /**
     * 初始化
     */
    init() {
      this.initMainData();
      this.initMenuData();
    },


    async initMenuData() {
      const self = this;
      const postData = {};
      postData.searchItem = {
        type: 1,
      };
      postData.token = self.$store.getters.getToken;
      postData.order = {
        listorder: 'desc'
      };

      try {
        var res = await self.$$api_labelGet({
          data: postData
        });
      } catch (err) {
        console.log(err);
        self.$notify('网络故障', 'error');
      };

      if (res) {
        self.optionData.labelOptions = res.info.data;
      };
      console.log('self.optionData', self.optionData)

    },

    /**
     * 列表主函数
     */
    async initMainData(isNew) {

      const self = this;
      self.table_arguments.loading = true;
      const postData = {};
      if (isNew) {
        self.paginate.currentPage = 1;
      };
      postData.paginate = self.$$cloneForm(self.paginate);
      postData.token = self.$store.getters.getToken;
      if (self.searchItem) {
        postData.searchItem = self.$$cloneForm(self.searchItem)
      };
      if (JSON.stringify(self.getBefore) != "{}") {
        postData.getBefore = self.$$cloneForm(self.getBefore);
      };

      postData.getAfter = {
        file: {
          condition: "in",
          key: "relation_id",
          middleKey: "id",
          searchItem: {
            status: 1,
            // type:2
          },
          // order:{
          //   'create_time':'desc'
          // },
          tableName: "File",
          info:['path']
        },
      };


      var res = await self.$$api_articleGet({
        data: postData
      });
      res.info.data.forEach((item,index)=>{
        item.qrUrl = item.file.path
      })
      self.mainData = res.info.data;

      self.paginate.count = res.info.total;
      self.table_arguments.loading = false;

    }

  },


}



// WEBPACK FOOTER //
// ./src/views/content/art.js